import coldChainDeliveryDubai from "../../assets/images/Blog/chiller-fleet-chiller-van-rental-dubai-guide.webp";

import chilledCargoTemperatureGuide from "../../assets/images/Blog/chiller-fleet-perishables-temperature-controlled-transport-in-uae-refrigerated-trucks.jpg";

import globalVillageVendorDelivery from "../../assets/images/Home/chiller-van-for-refrigerated-transport.webp";

export const blogPosts = [
  {
    slug: "global-village-vendor-delivery-dubai",
    title: "Supplying Global Village: The Delivery Window Every Food Vendor Has to Work Around",
    image: globalVillageVendorDelivery,
    excerpt:
      "How food vendors supply Global Village: the 8am–3pm delivery window, van choice by stall type, transit from Ras Al Khor, and whether daily or seasonal hire costs less.",
  },
  {
    slug: "chilled-cargo-transport-temperature-guide",
    title: "What Temperature Does Chilled Cargo Need? A Product-by-Product Guide for UAE Transport",
    image: chilledCargoTemperatureGuide,
    excerpt:
      "The transport temperature each category of chilled cargo actually requires — produce, dairy, meat, bakery, pharmacy and flowers — and which products fall outside a chiller van's range.",
  },
  {
    slug: "cold-chain-delivery-in-dubai",
    title: "Dubai Urban Logistics: Cold Chain Delivery Guide by Neighbourhood",
    image: coldChainDeliveryDubai,
    excerpt:
      "How delivery conditions change block to block across Dubai — and which chiller van, freezer van, or dry van each district actually needs.",
  },
];
